export const moduleODConnector = {
    namespaced: true,
    state: {
        status: 'online'        // 'online' | 'offline'
    },
    getters: {
        status: (state) => state.status
    },
    mutations: {
        SET_STATUS(state, status) {
            state.status = status;
        }
    },
    actions: {
        updateStatus({ commit }, status) {
            commit('SET_STATUS', status);
        }
    }
}